export default {
  logo: {
    id: 'product_page_bestphoneplans_popup_logo_alt',
    defaultMessage: 'BestPhonePlans',
  },
  popupTitle: {
    id: 'product_page_bestphoneplans_popup_title',
    defaultMessage:
      'Get an exclusive BestPhonePlans promo code with this phone.',
  },
  popupBody: {
    id: 'product_page_bestphoneplans_popup_body',
    defaultMessage:
      'Pair this phone with a BestPhonePlans plan and get exclusive pricing. Apply the code at checkout on the BestPhonePlans site.',
  },
  stepsTitle: {
    id: 'product_page_bestphoneplans_popup_steps_title',
    defaultMessage: 'How to activate your savings',
  },
  step1: {
    id: 'product_page_bestphoneplans_popup_step1',
    defaultMessage: 'Buy any unlocked phone on Back Market.',
  },
  step2: {
    id: 'product_page_bestphoneplans_popup_step2',
    defaultMessage: 'Get the promo code in your confirmation email.',
  },
  step3: {
    id: 'product_page_bestphoneplans_popup_step3',
    defaultMessage: 'Use your code when subscribing to a BestPhonePlans plan.',
  },
  closeButtonLabel: {
    id: 'product_page_bestphoneplans_popup_close_button_label',
    defaultMessage: 'Close "BestPhonePlans" popup',
  },
}
